import styled from 'styled-components';

import { colors, radius } from '../../../../styles/tokens';

export const Content = styled.div`
  width: 100%;
  min-height: 100%;

  padding: 40px;

  display: flex;
  flex-direction: column;
  gap: 24px;

  @media (max-width: 1199px) {
    padding: 20px;
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const BackButton = styled.button`
  align-self: flex-start;

  display: flex;
  align-items: center;
  gap: 6px;

  background: transparent;
  border: none;
  cursor: pointer;

  font-size: 13px;
  font-weight: 600;
  color: ${colors.onSurfaceVariant};

  transition: color 0.2s;

  &:hover {
    color: ${colors.onSurface};
  }
`;

export const HeaderTop = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;

  @media (max-width: 1199px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const HeaderInfo = styled.div`
  min-width: 0;
  flex: 1 1 auto;

  display: flex;
  flex-direction: column;
  gap: 8px;
`;

interface statusBadgeProps {
  is_active?: boolean;
}

export const StatusBadge = styled.span<statusBadgeProps>`
  align-self: flex-start;

  padding: 4px 12px;
  border-radius: ${radius.full};

  font-size: 10px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.1em;

  background-color: ${({ is_active }) =>
    is_active ? '#32a54a1a' : `${colors.error}1a`};
  color: ${({ is_active }) => (is_active ? '#32a54a' : colors.error)};
  border: 1px solid
    ${({ is_active }) => (is_active ? '#32a54a40' : `${colors.error}40`)};
`;

export const PageTitle = styled.h1`
  font-size: 40px;
  font-weight: 800;
  color: ${colors.onSurface};
  letter-spacing: -0.02em;
  overflow-wrap: break-word;
`;

export const PageSubtitle = styled.p`
  font-size: 13px;
  color: ${colors.onSurfaceVariant};
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`;

export const UnlockButton = styled.button`
  flex-shrink: 0;

  display: flex;
  align-items: center;
  gap: 8px;

  padding: 14px 24px;
  border-radius: ${radius.md};
  border: none;

  background-color: ${colors.primary};
  color: ${colors.onPrimary};

  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;

  cursor: pointer;
  transition: filter 0.2s;

  &:hover {
    filter: brightness(1.05);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const StatsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 20px;

  @media (max-width: 1199px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 700px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const MainGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(0, 1fr);
  gap: 24px;

  @media (max-width: 1199px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;
